import { doGet } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const getDetail = async (token, refresh_token, id, dispatch) => {
  const url = `${GROLOG_URL}/company-profile/${id}`;
  let result = { data: undefined, ok: false };

  dispatch(setTableLoading(true));
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false));
  return result
};

export const detail = async (token, id) => {
  const url = `${GROLOG_URL}/company-profile/${id}`;
  const result = { success: false, data: undefined };

  try {
    const res = await doGet(token, url);
    if (res?.data?.success) {
      result.success = true;
      result.data = res?.data?.payload?.data;
      
    }
  } catch (error) {
    return error
  }

  return result
};

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq uom, primary_key eq ${id}`;
  let result = { data: undefined, ok: false };

  try {
      const response = await doGet(token, url, null);
      if (response) {
          result.ok = true;
          result.data = response?.data?.payload
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
};

export const getOperationalDates = async (token) => {
  const url = `${GROLOG_URL}/company-profile/list-operational-date`;
  let result = { data: undefined, ok: false };
  // dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data;
    }
  } catch (error) {
    console.log(error);
    // checkValidationToken(error, token, refresh_token, dispatch)
  }
  // dispatch(setTableLoading(false))
  return result
};